import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-utshab',
  templateUrl: './events-utshab.component.html',
  styleUrls: ['./events-utshab.component.scss'],
})
export class EventsUtshabComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/utshab/1.jpg',
      thumbnail: 'assets/img/school/events/utshab/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/utshab/2.jpg',
      thumbnail: 'assets/img/school/events/utshab/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/utshab/3.jpg',
      thumbnail: 'assets/img/school/events/utshab/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/utshab/4.jpg',
      thumbnail: 'assets/img/school/events/utshab/4.jpg',
      alt: 'Image 01',
    }
  ];
}
